// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.568 3c.313 0 .567.254.567.568v15.567a.73.73 0 00.73.73h15.567a.568.568 0 110 1.135H4.865A1.865 1.865 0 013 19.135V3.568C3 3.254 3.254 3 3.568 3z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;